import type { IStrapiImage } from './strapiImage';

export type TvipReward = {
  icon: IStrapiImage;
  title: string;
  value: string;
  isEnabled: boolean;
};

export type vipLevelData = {
  id: number;
  level: number;
  groupId: string;
  title: string;
  messageText: string;
  compoints: number;
  levelImage: IStrapiImage;
  rewards: TvipReward[];
  locale: string;
  avatar: IStrapiImage;
  cashbackPercent: number;
  wager: number;
};

export enum EPlayerWritableGroup {
  VIP_LEVEL_ID = 'Vip-level-',
  VIP_LEVEL_UP_NOTIFY = 'level-up-notify-',
  LEVEL_UP_MODAL_SHOWN_ID = 'Vip-level-notify-shown-',
  SEO_BING = 'seo-bing',
  SEO_YAHOO = 'seo-yahoo',
  SEO_YANDEX = 'seo-yandex',
  SEO_DUCKDUCKGO = 'seo-duckduckgo',
  SEO_BAIDU = 'seo-baidu',
  SEO_ECOSIA = 'seo-ecosia',
  SEO_SEARCH_ASK_COM = 'seo-search.ask.com',
  SEO_GOOGLE = 'seo-google',
}

export enum EVipLevelStatus {
  passed = 'passed',
  active = 'active',
  blocked = 'blocked',
}

export enum EBonusType {
  FreeSpins = 'freeSpins',
  Cashback = 'cashback',
}

export interface IVipData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  level: number;
  groupId: string;
  bonusType: EBonusType;
  cashbackPercent: number;
  compoints: number;
  levelImage: IStrapiImage;
  title: string;
  messageText: string;
  rewards: {
    icon: IStrapiImage;
    title: string;
    value?: string;
    isEnabled: boolean;
  }[];
  avatar?: IStrapiImage;
  wager: number;
  locale: string;
}

export interface IVipStrapiResponse {
  data: IVipData[];
}
